import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/views/Index.vue";
import error from "@/views/404.vue";
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: Index,
  },
  {
    path: "/houselist",
    name: "houselist",
    component: () => import("@/views/Detail/houselist.vue"),
  },
  {
    path: "/detail/:id&:cityId",
    name: "detail",
    component: () => import("@/views/Detail/Detail.vue"),
  },
  {
    path: "/info/:id&:userid",
    name: "info",
    component: () => import("@/views/Info/Index.vue"),
  },
  {
    path: "/shareInfo/:id&:cityId",
    name: "shareInfo",
    component: () => import("@/views/ShareInfo/ShareInfo.vue"),
  },
  {
    path: "/shareWatch/:id&:cityId",
    name: "shareWatch",
    component: () => import("@/views/shareWatch/Sharewatch.vue"),
  },
  {
    path: "/contrast/:ids",
    name: "contrast",
    component: () => import("@/views/Contrast/Contrast.vue"),
  },
  {
    path: "/advertise/:id",
    name: "advertise",
    component: () => import("@/views/Advertise/Advertise.vue"),
  },
  {
    path: "/abortPlatform",
    name: "abortPlatform",
    component: () => import("@/views/AbortPlatform/AbortPlatform.vue"),
  },
  {
    path: "/rookieStrategy",
    name: "rookieStrategy",
    component: () => import("@/views/RookieStrategy/RookieStrategy.vue"),
  },
  {
    path: "/invite/:userId",
    name: "invite",
    component: () => import("@/views/Invite/Invite.vue"),
  },
  {
    path: "/inviteNew/:userId",
    name: "inviteNew",
    component: () => import("@/views/Invite/InviteNew.vue"),
  },
  {
    path: "/faceToFace/:userId",
    name: "face",
    component: () => import("@/views/FaceToFace/FaceToFace.vue"),
  },
  {
    path: "/inviteRegister/:userId",
    name: "inviteRegister",
    component: () => import("@/views/InviteRegister/InviteRegister.vue"),
  },
  {
    path: "/InviteRegisterNew/:userId",
    name: "inviteRegisterNew",
    component: () => import("@/views/InviteRegister/InviteRegisterNew.vue"),
  },
  {
    path: "/introduces",
    name: "introduces",
    component: () => import("@/views/Introduces/Introduces.vue"),
  },
  {
    path: "/serviceAgreement",
    name: "serviceAgreement",
    component: () => import("@/views/ServiceAgreement/ServiceAgreement.vue"),
  },
  {
    path: "/vipService",
    name: "vipService",
    component: () => import("@/views/VipService/VipService.vue"),
  },
  {
    path: "/countDownload",
    name: "countDownload",
    component: () => import("@/views/CountDownload/countDownload.vue"),
  },
  {
    path: "/insureService",
    name: "insureService",
    component: () => import("@/views/InsureService/InsureService.vue"),
  },
  {
    path:'/privacy_policy',
    name:'privacy_policy',
    component: () => import("@/views/privacy_policy/privacy_policy.vue"),
  },
  {
    path:'/authentication_privacy',
    name:'AuthenticationPrivacy',
    component: () => import("@/views/authenticationPrivacy/authentication_privacy.vue"),
  },
  {
    path:'/DyInformation',
    name:'DyInformation',
    component: () => import("@/views/DyInformation/DyInformation.vue"),
  },
  {
    path:'/rightDetail',
    name:'rightDetail',
    component: () => import("@/views/rightDetail/rightDetail.vue"),
  },
  {
    path:'/ActivityRules',
    name:'ActivityRules',
    component: () => import("@/views/ActivityRules/ActivityRules.vue"),
  },
  {
    path:'/PayRules',
    name:'PayRules',
    component: () => import("@/views/PayRules/PayRules.vue"),
  },
  {
    path:'/VipServer',
    name:'VipServer',
    component: () => import("@/views/VipServer/VipServer.vue"),
  },
  {
    path:'/MerchantsRights',
    name:'MerchantsRights',
    component: () => import("@/views/MerchantsRights/MerchantsRights.vue"),
  },
  // 客户意见表页面
  {
    path:'/Customerintention',
    name:'Customerintention',
    component: () => import("@/views/Customerintention/Customerintention.vue"),
  },
  // 落地页
  {
    path:'/Landingpage',
    name:'Landingpage',
    component: () => import("@/views/Landingpage/Landingpage.vue"),
  },
  //  过渡页面，放2码合一的下载链接的
  {
    path:'/Transitionpage',
    name:'Transitionpage',
    component: () => import("@/views/Detail/Transitionpage.vue"),
  },
  // 邀请下载
  {
    path:'/godownload',
    name:'godownload',
    component: () => import("@/views/godownload/godownload.vue"),
  },
  // 查询楼盘
  {
    path:'/properties',
    name:'properties',
    component: () => import("@/views/properties/properties.vue"),
  },
  // 查询楼盘结果
  {
    path:'/searchresults',
    name:'searchresults',
    component: () => import("@/views/searchresults/searchresults.vue"),
  },
  //  邀请生成二维码页面
  {
    path:'/Invitationcode',
    name:'Invitationcode',
    component: () => import("@/views/Invitationcode/Invitationcode.vue"),
  },
  { path: "*", component: error },
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: "/mobile",
});

router.beforeEach((to, from, next) => {
  document.title = "房品优选";
  next();
});

export default router;
